<template>
<div>
  <template v-if="showNavigation">
    <div class="app-shade" @click="toggleSidebar" :class="activeClass"/>
    <side-bar v-if="user.password_changed" :active="activeClass"/>
  </template>

  <section class="app-main" :class="{ 'unauthenticated': !showNavigation || !user.password_changed  }">
    <div class="app-content" :class="{ 'unauthenticated': !showNavigation || !user.password_changed  }">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>

      <div class="system-updater" v-if="needsRefresh">
        <p>New updates are available!</p>
        <action-button class="is-cool-blue is-outlined is-rounded" @click="installUpdates">Refresh inBrief</action-button>
      </div>
    </div>
  </section>
  <toaster :max="1"/>
  <modal-wrapper transition-name="fade"/>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SideBar from '@/views/nav/SideBar'
import TopBar from '@/views/nav/TopBar'

export default {

  name: 'app',

  components: {
    TopBar,
    SideBar
  },

  data: () => ({
    sidebarOpen: false,
  }),

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.restrainSidebar);
      this.restrainSidebar()
    })
  },

  methods: {
    closeSidebar() {
      this.sidebarOpen = false
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    restrainSidebar() {
      if (document.documentElement.clientWidth >= 1024 && this.sidebarOpen) {
        this.closeSidebar()
      }
    },
    installUpdates() {
      localStorage.removeItem('needs_refresh')
      location.reload()
    },
  },

  computed: {
    ...mapGetters('auth', [
      'authenticated',
      'user'
    ]),
    ...mapGetters('company', [
      'company'
    ]),
    ...mapState({
      needsRefresh: state => state.app.needsRefresh
    }),
    activeClass() {
      return {
        'is-active': this.sidebarOpen
      }
    },
    showNavigation() {
      return (
        this.authenticated === true 
        && this.company.is_setup === true 
        && this.user.is_setup === true
      )
    }
  },
}
</script>

<style lang="scss">
@import "./assets/app.scss";
</style>
